export const ProfileModes = {
    VIEW: 'VIEW',
    EDIT: 'EDIT',
    CREATE: 'CREATE',
}
